module.exports = __webpack_public_path__ + "assets/1c4245b1de5b8f9d5b324c0940c0fea7.svg";